import { useEffect } from "react";
import { Helmet } from "react-helmet";
import InviteShareIcon from "@/assets/Icons/invite-share.svg?react";
import PhoneRingingIcon from "@/assets/Icons/phone-ringing.svg?react";
import ReceiptCheckIcon from "@/assets/Icons/receipt-check.svg?react";
import CoinSendIcon from "@/assets/Icons/coin-send.svg?react";
import ShoppingCartIcon from "@/assets/Icons/shopping-cart-check.svg?react";
import WithdrawalIcon from "@/assets/Icons/withdrawal-2.svg?react";
import SendIcon from "@/assets/Icons/send.svg?react";
import UserIcon from "@/assets/Icons/user.svg?react";
import RedDecoration from "@/assets/Img/ClaroPay/red-decoration.svg?react";
import LadyWithPhone from "@/assets/Img/ClaroPay/lady-with-phone.png";
import ClaroLogoWhite from "@/assets/Img/ClaroPay/claro-inline-logo-white.png";
import ClaroChatEn from "@/assets/Img/ClaroPay/claro-chat-en.png";
import ClaroChatEs from "@/assets/Img/ClaroPay/claro-chat-es.png";
import ClaroPayLogo from "@/assets/Img/ClaroPay/claropay-small.png";
import AppMockupEn from "@/assets/Img/ClaroPay/app-mockup-en.png";
import AppMockupEs from "@/assets/Img/ClaroPay/app-mockup-es.png";
import SendolaPayLogo from "@/assets/Img/logo-sendola-pay.png";
import PoweredBySendolaPayLogo from "@/assets/Img/powered-by-sendolapay.png";
import TelcelLogo from "@/assets/Img/ClaroPay/telcel-logo.png";
import MXIcon from "@/assets/Img/Flags/flag-mexico.png";
import USIcon from "@/assets/Img/Flags/flag-us.png";
import ClaroPayLargeLogo from "@/assets/Img/ClaroPay/claropay-large.svg?react";
import { Button } from "@/components/Button";
import { useTranslation } from "react-i18next";
import { ClaroNumberedCard } from "@/components/ClaroNumberedCard";
import { ClaroText } from "@/components/ClaroRaysText";
import {
  CLAROPAY_INVITE_TEXT,
  CLAROPAY_OPEN_ACCOUNT,
  CLAROPAY_PESO_X_MEGA_TERMS,
} from "@/constants/ClaroPay";
import Cookies from "universal-cookie";

const cookies = new Cookies();

export default function ClaroPayRecipient() {
  const [t, i18n] = useTranslation("global");
  const lang = i18n.language;

  const copyUrl = `${window.location.origin}/claropay-send`;

  const shareInvite = () => {
    gtag("event", "ShareClaroPay_sendme");

    if (navigator?.share || navigator?.canShare()) {
      const shareOptions = {
        text: CLAROPAY_INVITE_TEXT,
        url: copyUrl,
      };

      navigator.share(shareOptions);
    }
  };

  useEffect(() => {
    const languageSet = Boolean(localStorage.getItem("languageSet"));

    setTimeout(() => {
      if (!languageSet) {
        i18n.changeLanguage("es", () => {
          cookies.set("lang", "es");
          localStorage.setItem("languageSet", "true");
        });
      }
    }, 100);
  }, []);

  return (
    <>
      <Helmet>
        <title>Sendola | ClaroPay</title>
      </Helmet>
      <div className="w-full flex flex-col items-center justify-center relative bg-lightblue">
        {/* Header Desktop */}
        <div className="w-full h-[22rem] bg-gradient-to-b from-[#f60208] via-[#f20208] to-[#a30003] relative hidden overflow-hidden md:block">
          <RedDecoration className="w-[24%] max-w-[] h-[22rem] absolute bottom-0 left-0 translate-y-4" />
          <div className="w-full h-full flex items-center justify-between z-10 relative">
            <div className="w-[53%] h-full flex flex-col justify-between">
              <div className="flex justify-center items-center h-full w-full">
                <div className="flex flex-col gap-4 items-center justify-center px-6">
                  <h1
                    className="text-2xl lg:text-3xl xl:text-4xl text-white text-center max-w-[34rem] inner-span-bolden font-light"
                    dangerouslySetInnerHTML={{
                      __html: t("ClaroPay.recipient.headingTitle"),
                    }}
                  />

                  <div className="flex flex-col justify-center items-end gap-2">
                    <img
                      className="w-auto h-12 object-contain object-bottom"
                      src={ClaroLogoWhite}
                      alt="Claro Pay's logo"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="w-[47%] h-full flex justify-center items-end lg:px-4">
              <img
                className="w-full max-w-[32rem] h-full object-contain object-bottom"
                src={LadyWithPhone}
                alt="Lady with smartphone"
              />
            </div>
          </div>
        </div>

        {/* Header Mobile */}
        <div className="relative flex flex-col items-center w-full max-xs:max-h-[24rem] h-[26rem] sm:h-[28rem] md:h-[30rem] bg-gradient-to-b from-[#f60208] via-[#f20208] to-[#a30003] md:hidden overflow-hidden">
          <RedDecoration className="w-[14rem] h-[20rem] absolute bottom-0 left-0 translate-y-4" />
          <div className="flex flex-col gap-4 items-center justify-center px-6 pt-6">
            <h1
              className="text-xl text-white text-center inner-span-bolden font-light"
              dangerouslySetInnerHTML={{
                __html: t("ClaroPay.recipient.headingTitle"),
              }}
            />

            <div className="flex justify-center items-end gap-2">
              <img
                className="w-auto h-9 object-contain object-bottom"
                src={ClaroLogoWhite}
                alt="Claro Pay's logo"
              />
            </div>
          </div>

          <img
            className="w-auto h-[20rem] max-xs:max-h-[15rem] max-sm:max-h-[16rem] object-contain object-bottom z-20 absolute px-6 bottom-0"
            src={LadyWithPhone}
            alt="Lady with smartphone"
          />
        </div>
        <div className="flex items-center justify-center w-full px-6 py-4 bg-white">
          <div className="flex flex-col md:flex-row items-center justify-center w-full max-w-screen-xl gap-x-8 gap-y-3">
            <div className="w-full min-h-20 h-auto md:min-h-32 lg:min-h-28 flex items-center justify-between gap-2 rounded-2xl border-[1px] border-[#ececec] py-3 px-4">
              <div className="flex flex-col gap-1 flex-1 flex-shrink-0 max-w-[360px]">
                <p className="text-sm md:text-base font-semibold text-center">
                  {t("ClaroPay.recipient.openAccount")}
                </p>
                <a
                  href="#descubre"
                  className="text-xs md:text-sm font-semibold text-center text-primary-500 hover:text-primary-400"
                >
                  {t("ClaroPay.recipient.knowMore")}
                </a>
              </div>
              <Button
                target="_blank"
                rel={["noopener", "noreferrer"]}
                link={CLAROPAY_OPEN_ACCOUNT}
                className="!w-28 xs:!w-40 xs:!px-4 lg:!w-52 !h-12 !text-xs xs:!text-sm lg:!text-base !border-0 rounded-full !bg-gradient-to-r from-[#f60208] via-[#f20208] to-[#a30003]"
              >
                {t("ClaroPay.recipient.joinClaro")}
              </Button>
            </div>
            <div className="w-full min-h-20 h-auto md:min-h-32 lg:min-h-28 flex items-center justify-between gap-2 rounded-2xl border-[1px] border-[#ececec] py-3 px-4">
              <div className="flex flex-col gap-1 flex-1 flex-shrink-0 max-w-[360px]">
                <p className="text-sm md:text-base font-semibold text-center">
                  {t("ClaroPay.recipient.iHaveAccount")}
                </p>
                <p className="text-xs font-semibold text-center">
                  {t("ClaroPay.recipient.shareThisLink")}
                </p>
              </div>
              <Button
                onClick={shareInvite}
                className="!w-28 xs:!w-40 xs:!px-4 lg:!w-56 !h-12 !text-xs xs:!text-sm lg:!text-base rounded-full !bg-primary-500 !border-0"
              >
                {t("ClaroPay.recipient.askFor")}
              </Button>
            </div>
          </div>
        </div>

        <div className="w-full flex items-center justify-center flex-col-reverse md:flex-row">
          <div className="w-full md:w-[40%] lg:w-1/3 flex md:flex-col items-center 2xl:items-end justify-end max-w-screen-md">
            <div className="w-full h-auto flex flex-col items-center gap-2 pt-20">
              <p className="block md:hidden text-2xl xs:text-3xl text-center font-semibold px-6">
                {t("ClaroPay.recipient.simpleSteps")}
              </p>

              <div className="flex justify-between md:justify-end w-full gap-12 pt-6">
                <div className="flex flex-col items-center justify-center -translate-x-36 -mr-56 sm:-translate-x-20 sm:-mr-40 md:translate-x-0 md:mr-0">
                  {lang === "en" ? (
                    <img
                      className="object-contain md:w-full h-auto max-w-[22rem] md:max-w-[34rem] flex-shrink-0 max-xs:hidden"
                      src={AppMockupEn}
                      alt=""
                    />
                  ) : (
                    <img
                      className="object-contain md:w-full h-auto max-w-[22rem] md:max-w-[34rem] flex-shrink-0 max-xs:hidden"
                      src={AppMockupEs}
                      alt=""
                    />
                  )}
                  <img
                    className="hidden md:block w-auto h-8 lg:h-10 object-contain -translate-y-4 lg:-translate-y-8"
                    src={PoweredBySendolaPayLogo}
                    alt="Powered by SendolaPay"
                  />
                </div>

                <div className="flex md:hidden flex-col gap-4 items-center px-6 w-full">
                  <ClaroNumberedCard
                    number={1}
                    position="top-left"
                    text={t("ClaroPay.recipient.cards.card1")}
                    className="!mx-0 pt-4 max-xs:!h-44"
                    numberClassName="max-xs:!left-[48%]"
                  >
                    <Button
                      onClick={shareInvite}
                      className="bg-primary-500 !text-sm !px-4 !py-1 mt-2 !gap-2"
                      icon={
                        <InviteShareIcon className="text-white w-5 h-5 flex-shrink-0" />
                      }
                    >
                      {t("ClaroPay.recipient.invite")}
                    </Button>
                  </ClaroNumberedCard>
                  <ClaroNumberedCard
                    number={2}
                    position="top-left"
                    text={t("ClaroPay.recipient.cards.card2")}
                    className="!mx-0 pt-4 max-xs:!h-44"
                    numberClassName="max-xs:!left-[48%]"
                  >
                    <UserIcon className="w-12 h-12 text-primary-500 flex-shrink-0 mt-2" />
                  </ClaroNumberedCard>
                  <ClaroNumberedCard
                    number={3}
                    position="top-left"
                    text={t("ClaroPay.recipient.cards.card3")}
                    className="!mx-0 pt-4 max-xs:!h-44"
                    numberClassName="max-xs:!left-[48%]"
                  >
                    <SendIcon className="w-12 h-12 text-primary-500 flex-shrink-0 mt-2" />
                  </ClaroNumberedCard>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full md:w-[60%] lg:w-2/3 flex flex-col items-center justify-center gap-12 max-w-screen-xl">
            <div className="w-full flex justify-center items-center gap-x-4 gap-y-2 lg:gap-x-6 lg:gap-y-2 pt-8 flex-wrap">
              <img
                className="h-12 sm:h-14 md:h-16 lg:h-20 w-auto object-contain"
                src={SendolaPayLogo}
                alt="SendolaPay's logo"
              />
              <img
                className="h-12 sm:h-14 md:h-16 lg:h-20 w-auto object-contain"
                src={ClaroPayLogo}
                alt="ClaroPay's logo"
              />
              <img
                className="h-10 sm:h-12 md:h-14 lg:h-16 w-auto object-contain"
                src={TelcelLogo}
                alt="ClaroPay's logo"
              />
            </div>

            <div className="w-fit flex flex-col gap-1 px-6">
              <ClaroText
                text={t("ClaroPay.recipient.lines.line1")}
                extra={
                  <div className="hidden sm:flex items-center w-fit pl-2">
                    <img
                      className="w-7 h-7 md:w-8 md:h-8 flex-shrink-0"
                      src={USIcon}
                      alt="US"
                    />
                    <img
                      className="w-7 h-7 md:w-8 md:h-8 -ml-[10%] flex-shrink-0"
                      src={MXIcon}
                      alt="MX"
                    />
                  </div>
                }
              />
              <ClaroText text={t("ClaroPay.recipient.lines.line2")} />
              <ClaroText text={t("ClaroPay.recipient.lines.line3")} />
            </div>

            <div className="w-full flex flex-col items-center justify-center gap-4 px-10">
              {lang === "en" ? (
                <img
                  className="object-contain w-full h-auto max-w-[30rem] -my-6"
                  src={ClaroChatEn}
                  alt="Chat example"
                />
              ) : (
                <img
                  className="object-contain w-full h-auto max-w-[30rem] -my-6"
                  src={ClaroChatEs}
                  alt="Chat de ejemplo"
                />
              )}
              <p
                className="text-xs font-medium max-w-[30rem] text-center inner-a-link"
                dangerouslySetInnerHTML={{
                  __html: t("ClaroPay.recipient.chatDisclaimer", {
                    link: CLAROPAY_PESO_X_MEGA_TERMS,
                  }),
                }}
              />
            </div>
          </div>
        </div>

        <div className="w-full hidden md:flex items-center justify-center px-10 pt-12">
          <div className="w-full flex flex-col items-center max-w-screen-xl gap-6">
            <p className="text-2xl xs:text-3xl text-center font-semibold px-6">
              {t("ClaroPay.recipient.simpleSteps")}
            </p>

            <div className="w-full flex justify-around gap-10 mt-6">
              <ClaroNumberedCard
                className="!px-8 !pt-4 !h-56"
                number={1}
                text={t("ClaroPay.recipient.cards.card1")}
              >
                <Button
                  onClick={shareInvite}
                  className="bg-primary-500 !text-sm !px-4 !py-1 mt-2 !gap-2"
                  icon={
                    <InviteShareIcon className="text-white w-5 h-5 flex-shrink-0" />
                  }
                >
                  {t("ClaroPay.recipient.invite")}
                </Button>
              </ClaroNumberedCard>
              <ClaroNumberedCard
                className="!px-8 !pt-4 !h-56"
                number={2}
                text={t("ClaroPay.recipient.cards.card2")}
              >
                <UserIcon className="w-12 h-12 text-primary-500 flex-shrink-0 mt-2" />
              </ClaroNumberedCard>
              <ClaroNumberedCard
                className="!px-8 !pt-4 !h-56"
                number={3}
                text={t("ClaroPay.recipient.cards.card3")}
              >
                <SendIcon className="w-12 h-12 text-primary-500 flex-shrink-0 mt-2" />
              </ClaroNumberedCard>
            </div>
          </div>
        </div>

        <div className="w-full flex justify-center items-center gap-8 px-6 py-6 md:hidden bg-white mt-20">
          <p className="sm:text-xl font-semibold text-left">
            {t("ClaroPay.recipient.shareThisLink")}
          </p>
          <Button
            onClick={shareInvite}
            icon={
              <InviteShareIcon className="text-white w-6 h-6 flex-shrink-0" />
            }
            className="!text-base rounded-full !bg-primary-500 !border-0 !px-4 !gap-2"
          >
            {t("ClaroPay.recipient.invite")}
          </Button>
        </div>

        <div
          id="descubre"
          className="w-full flex justify-center px-6 md:px-10 bg-[#d72d25] py-14 md:py-20 gap-10 md:mt-20"
        >
          <div className="w-full flex flex-col items-center md:flex-row justify-around gap-8 max-w-screen-xl">
            <div className="w-full md:w-fit flex flex-col gap-2 md:gap-4 text-white flex-1 flex-shrink-0">
              <p className="text-3xl lg:text-4xl font-medium w-fit md:max-w-md">
                {t("ClaroPay.recipient.noAccount")}
              </p>
              <p className="text-lg lg:text-xl font-light w-fit">
                {t("ClaroPay.recipient.explore")}
              </p>
            </div>
            <div className="w-full min-w-[60%] bg-white rounded-3xl flex flex-col gap-4 h-auto py-10 px-6 md:px-10 flex-1 flex-shrink-0">
              <div className="flex items-center p-[0.75] gap-5">
                <div className="w-auto">
                  <div className="w-[42px] h-[42px] flex items-center justify-center rounded-full bg-[#d92f27]">
                    <SendIcon width={25} height={25} className="text-white" />
                  </div>
                </div>
                <p
                  className="text-left text-base lg:text-lg inner-span-bolden"
                  dangerouslySetInnerHTML={{
                    __html: t("ClaroPay.recipient.features.feature1"),
                  }}
                />
              </div>
              <div className="flex items-center p-[0.75] gap-5">
                <div className="w-auto">
                  <div className="w-[42px] h-[42px] flex items-center justify-center rounded-full bg-[#d92f27]">
                    <PhoneRingingIcon
                      width={25}
                      height={25}
                      className="text-white"
                    />
                  </div>
                </div>
                <p
                  className="text-left text-base lg:text-lg inner-span-bolden"
                  dangerouslySetInnerHTML={{
                    __html: t("ClaroPay.recipient.features.feature2"),
                  }}
                />
              </div>
              <div className="flex items-center p-[0.75] gap-5">
                <div className="w-auto">
                  <div className="w-[42px] h-[42px] flex items-center justify-center rounded-full bg-[#d92f27]">
                    <ReceiptCheckIcon
                      width={25}
                      height={25}
                      className="text-white"
                    />
                  </div>
                </div>
                <p
                  className="text-left text-base lg:text-lg inner-span-bolden"
                  dangerouslySetInnerHTML={{
                    __html: t("ClaroPay.recipient.features.feature3"),
                  }}
                />
              </div>
              <div className="flex items-center p-[0.75] gap-5">
                <div className="w-auto">
                  <div className="w-[42px] h-[42px] flex items-center justify-center rounded-full bg-[#d92f27]">
                    <CoinSendIcon
                      width={32}
                      height={32}
                      className="text-white"
                    />
                  </div>
                </div>
                <p
                  className="text-left text-base lg:text-lg inner-span-bolden"
                  dangerouslySetInnerHTML={{
                    __html: t("ClaroPay.recipient.features.feature4"),
                  }}
                />
              </div>
              <div className="flex items-center p-[0.75] gap-5">
                <div className="w-auto">
                  <div className="w-[42px] h-[42px] flex items-center justify-center rounded-full bg-[#d92f27]">
                    <WithdrawalIcon
                      width={25}
                      height={25}
                      className="text-white"
                    />
                  </div>
                </div>
                <p
                  className="text-left text-base lg:text-lg inner-span-bolden"
                  dangerouslySetInnerHTML={{
                    __html: t("ClaroPay.recipient.features.feature5"),
                  }}
                />
              </div>
              <div className="flex items-center p-[0.75] gap-5">
                <div className="w-auto">
                  <div className="w-[42px] h-[42px] flex items-center justify-center rounded-full bg-[#d92f27]">
                    <ShoppingCartIcon
                      width={25}
                      height={25}
                      className="text-white"
                    />
                  </div>
                </div>
                <p
                  className="text-left text-base lg:text-lg inner-span-bolden"
                  dangerouslySetInnerHTML={{
                    __html: t("ClaroPay.recipient.features.feature6"),
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="w-full flex flex-col items-center justify-center gap-10 md:gap-8 p-10 bg-white">
          <div className="flex items-center gap-x-4 gap-y-3 flex-wrap justify-center">
            <p className="text-2xl md:font-medium text-center md:text-left">
              {t("ClaroPay.recipient.signUp")}
            </p>
            <div className="flex gap-4">
              <ClaroPayLargeLogo className="pb-2 h-10 w-auto" />
            </div>
          </div>

          <Button
            link={CLAROPAY_OPEN_ACCOUNT}
            target="_blank"
            className="!font-normal !bg-[#c51f1a] !border-0 w-fit !py-3 !px-8"
          >
            {t("ClaroPay.recipient.apply")}
          </Button>
        </div>
      </div>
    </>
  );
}
